import {  Response }   from '@angular/http';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

export class ServiceUtil {

  // extrai lista da resposta http
  public extractData(res: Response) {
    let body = res.json();
    return body.data || { };
  }

  // manipula erros da resposta http
  public handleError(err: HttpErrorResponse | any): Observable<any> {
		let errMsg: string;

    switch (err.status) {
			case 400:
				errMsg = "Solicitação inválida. Tente mais tarde!";
				break;
			case 401:
				errMsg = "Acesso negado para a funcionalidade requisitada!";
				break;
			case 403:
				errMsg = "Autenticação necessária!";
				break;
			case 404:
				errMsg = "Servidor de dados indisponível. Tente mais tarde!";
				break;
			case 444:
				errMsg = "Servidor de dados não respondeu à requisição!";
				break;
			case 500:
				errMsg = "Erro interno do servidor. Tente mais tarde!";
				break;
			case 501:
				errMsg = "Funcionalidade não implementada!";
				break;
			case 503:
				errMsg = "Serviço indisponível. Tente mais tarde!";
				break;
			case 511:
				errMsg = "Autenticação de rede necessária!";
				break;
			case 598:
				errMsg = "A rede demorou para responder à requisição!";
				break;
			case 599:
				errMsg = "A rede demorou para estabelecer uma conexão!";
				break;
			default:
				if (err.message) {
					errMsg = err.message;
				} else {
					errMsg = "Erro indeterminado. Consulte o administrador do sistema!"
				}
				break;
		}
		return throwError(errMsg);
	}


}
